// extracted by mini-css-extract-plugin
export default {"main":"feed_main__0zLtP","section":"feed_section__sa8rL"};